import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

const MetodosEnsenanzaPage: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleThemeChange = (theme: number) => {
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    const metodos = [
        {
            id: 1,
            imagen: '/images/infosection/lecturaguiada.png',
            titulo: t('Lectura Guiada', 'Guided Reading'),
            descripcion: t('Lectura interactiva y guiada para desarrollar comprensión lectora y pensamiento crítico.', 'Interactive and guided reading to develop reading comprehension and critical thinking.')
        },
        {
            id: 2,
            imagen: '/images/infosection/experimentosociales.png',
            titulo: t('Experimentos Sociales', 'Social Experiments'),
            descripcion: t('Experimentos prácticos que fomentan la interacción social y el aprendizaje colaborativo.', 'Practical experiments that foster social interaction and collaborative learning.')
        },
        {
            id: 3,
            imagen: '/images/infosection/reflexionaprendizaje.png',
            titulo: t('Reflexión y Aprendizaje', 'Reflection and Learning'),
            descripcion: t('Momentos de reflexión profunda para asimilar y procesar el conocimiento adquirido.', 'Deep reflection moments to assimilate and process acquired knowledge.')
        },
        {
            id: 4,
            imagen: '/images/infosection/aprendizajeproyectos.png',
            titulo: t('Aprendizaje por Proyectos', 'Project-Based Learning'),
            descripcion: t('Desarrollo de proyectos prácticos que integran múltiples áreas de conocimiento.', 'Development of practical projects that integrate multiple areas of knowledge.')
        },
        {
            id: 5,
            imagen: '/images/infosection/debateyjuegodebate.png',
            titulo: t('Debate y Juego de Debate', 'Debate and Debate Games'),
            descripcion: t('Actividades de debate estructurado que desarrollan habilidades de comunicación y argumentación.', 'Structured debate activities that develop communication and argumentation skills.')
        },
        {
            id: 6,
            imagen: '/images/infosection/tutoriapersonalizada.png',
            titulo: t('Tutoría Personalizada', 'Personalized Tutoring'),
            descripcion: t('Acompañamiento individualizado que se adapta al ritmo y necesidades de cada niño.', 'Individualized accompaniment that adapts to each child\'s pace and needs.')
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
            {/* Navbar */}
            <Navbar currentTheme={1} onThemeChange={handleThemeChange} />
            
            {/* Contenido principal */}
            <main className="pt-16">
                {/* Sección de título y descripción */}
                <section className="py-16 lg:py-24 bg-gradient-to-r from-blue-600 to-purple-700">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="max-w-4xl mx-auto">
                            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                                {t('Métodos de Enseñanza', 'Teaching Methods')}
                            </h1>
                            <p className="text-xl sm:text-2xl text-blue-100 leading-relaxed">
                                {t(
                                    'En Princonser Kids combinamos una gran variedad de estrategias y técnicas para que los niños aprendan, apliquen y retengan el conocimiento con todos sus sentidos.',
                                    'At Princonser Kids we combine a wide variety of strategies and techniques so that children learn, apply and retain knowledge with all their senses.'
                                )}
                            </p>
                        </div>
                    </div>
                </section>

                {/* Sección de métodos */}
                <section className="py-16 lg:py-24">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {metodos.map((metodo) => (
                                <div key={metodo.id} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
                                    {/* Imagen */}
                                    <div className="h-64 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-6">
                                        <img 
                                            src={metodo.imagen}
                                            alt={metodo.titulo}
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                    
                                    {/* Contenido */}
                                    <div className="p-6">
                                        <h3 className="text-2xl font-bold text-gray-900 mb-3">
                                            {metodo.titulo}
                                        </h3>
                                        <p className="text-gray-700 leading-relaxed">
                                            {metodo.descripcion}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Botones de navegación */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-16">
                            <button 
                                onClick={() => navigate('/')}
                                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-700 text-white rounded-full font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                            >
                                {t('Volver al Inicio', 'Back to Home')}
                            </button>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default MetodosEnsenanzaPage; 